export default __webpack_public_path__ + "static/media/header.b16bb34d.jpg";